import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRoute, Routes } from '@angular/router';
import { InsightsService } from '../services/services.module';
import { Observable, throwError } from 'rxjs';
import { ActivatedRouteSnapshot } from '@angular/router';
import { AppCache } from '../components/survale-common/cache/app.cache';
import * as _ from 'lodash';

@Injectable()
export class InsightsResolver  {
  // private cache: AppCache = AppCache.getInstance();
  // private cacheTypes = AppCache.cacheTypes();

  constructor(private activatedRoute: ActivatedRoute,
    private insightsService: InsightsService) {

  }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    // const cached = this.cache.getCache(this.cacheTypes.View, '');
    // if (cached) {
    //   return cached;
    // }
    return this.insightsService.getUsersSurveyInsights();
  }
}
